/**
 * TextTypeWriterAnimation.js
 * 
 * Created on 26/01/2016
 *
 * @author Henrique Campos for Ranj
 **/

 import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
 import TextWrap from "/lib/html5-software-library/src/ranj/components/text/TextWrap";

 const TextTypeWriterAnimation = {};
 export default TextTypeWriterAnimation;
 
 /**
  * Animates text as if typed
  * @param {createjs.Text} textField 
  * @param {String} resultText 
  * @param {Number} timeInSecs 
  * @param {Number} delayInSecs 
  * @param {Function} ease - see createjs.Ease
  * @param {Function} onComplete 
  * @param {Boolean} animateRTL - If true, animates text from right to left (for RTL languages like Arabic)
  * @returns {Function} animation object with 'forceFinish' method
  */
 TextTypeWriterAnimation.animate = (textField, resultText, timeInSecs, delayInSecs = 0, ease = createjs.Ease.quadOut, onComplete = null, animateRTL = false) => {
     const delay = delayInSecs * 1000;
     const time = timeInSecs * 1000;
 
     //Use wrapped text for animation, so no jerky effect occurs when words are suddenly placed on next line when they get longer
     textField.text = resultText;
     
     // Use TextWrap to properly wrap text including CJK characters
     const context = textField._prepContext(createjs.Text._workingContext);
     const lineWidth = textField.lineWidth;
     const wrappedText = TextWrap.wrapText(resultText, lineWidth, context, '\n');
     
     textField.text = "";
 
     const animation = function(text) {
         // Lerps a value from 0 to 1, and uses it to determine the substring size to show in the text field
         const proxy = { value: 0 };
         const onUpdate = function(e) {
             // calculate substring size
             const length = Math.ceil(text.length * proxy.value);
             
             textField.text = text.substring(0, length);
         }
         const onTweenComplete = function() {
             if (onComplete != null) {
                 onComplete(this);
             }
         }.bind(this);
         
         createjs.Tween.get(proxy, { onChange: onUpdate, onComplete: onTweenComplete }).wait(delay).to({ value: 1 }, time, ease);
 
         // forces the animation to finish
         this.forceFinish = function() {
             createjs.Tween.removeTweens(proxy);
             proxy.value = 1;
             onUpdate();
             onTweenComplete();
         };
 
         return this;
     };
 
     return new animation(wrappedText);
 };
 
 